export const getDomainHeader = () => {
  return window._STENN_.CULTURE === 'common' ? 'GLOBAL' : 'CHINA';
};
